import { render, staticRenderFns } from "./FieldHolder.vue?vue&type=template&id=160a7636&"
import script from "./FieldHolder.vue?vue&type=script&lang=ts&"
export * from "./FieldHolder.vue?vue&type=script&lang=ts&"
import style0 from "./FieldHolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports